import React, { useCallback, useEffect } from "react";
import AuthService from "../../services/auth.service";

export default function TermsAndConditions() {
  useEffect(() => {
    getTermsAndConditions();
  }, []);
  const getTermsAndConditions = useCallback(async () => {
    try {
      const response = await AuthService.getTermsAndConditions({});
      if (response.status === 200) {
      }
    } catch (error) {}
  }, []);
  return (
    <>
    </>
  );
}
